module.exports = __webpack_public_path__ + "1.5.0-unryo/img/extreme-networks.7404ff1c.png";